<section>
  <div class="comments">
    <app-comments-list [comments]="commentsWithRate"></app-comments-list>
  </div>

  <!-- <div class="scoreboard">
    <app-scoreboard-list></app-scoreboard-list>
  </div> -->
</section>
